import React from "react";
import { Link } from "react-router-dom";

import "../../Styles/ReportCard.css";

const ReportCard = ({
  toptext,
  bottomtext,
  numbertrue,
  numberfalse,
  buttontext,
  buttonLink,
}) => {
  return (
    <div className="FalseTrue">
      <div className="FalseTrue-inside">
        <div className="FalseTrue-inside-div">
          <p className="FalseTrue-inside-div-1">{toptext}</p>
          <p className="FalseTrue-inside-div-2">{bottomtext}</p>

          <div className="FalseTrue-inside-div-3">
            <div className="FalseTrue-inside-div-3-top">
              <div className="FalseTrue-inside-div-3-top-right">
                <img
                  className="FalseTrue-inside-div-3-top-right-img"
                  src="/imgs/Exam/True.svg"
                />
                <p className="FalseTrue-inside-div-3-top-right-text">
                  پاسخ درست
                </p>
              </div>
              <div className="FalseTrue-inside-div-3-top-left">
                <img
                  className="FalseTrue-inside-div-3-top-left-img"
                  src="/imgs/Exam/False.svg"
                />
                <p className="FalseTrue-inside-div-3-top-left-text">پاسخ غلط</p>
              </div>
            </div>
            <div className="FalseTrue-inside-div-3-bottom">
              <div className="FalseTrue-inside-div-3-bottom-right">
                {numbertrue}
              </div>
              <p className="FalseTrue-inside-div-3-bottom-center">-</p>
              <div className="FalseTrue-inside-div-3-bottom-left">
                {numberfalse}
              </div>
            </div>
          </div>

          <div className="FalseTrue-inside-div-4">
            <Link to={buttonLink} className="FalseTrue-inside-div-4-button">
              {buttontext}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportCard;
